
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Filtro, Pesquisa } from '@app/model/util';
import { Aplicacao, SubAplicacao, TipoTarefa, Concurso, ConcursoAplicacaoTipoTarefa } from '@app/model';


@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  options: {
    headers?: HttpHeaders | { [header: string]: string | string[] },
    observe?: 'body' | 'events' | 'response',
    params?: HttpParams | { [param: string]: string | string[] },
    reportProgress?: boolean,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    withCredentials?: boolean,
  }

  // Apontamos ao 4200(front) porque temos a proxy aplicada
  url = '/apiat';

  urlAplicacao = this.url + '/aplicacao';
  urlSubAplicacao = this.url + '/subaplicacao';
  urlTipoTarefa = this.url + '/tipotarefa';
  urlConcurso = this.url + '/concurso';

  urlLista = "/lista";
  urlSearch = "/search";
  urlCount = "/count";
  urlObter = "/";
  urlInserirAlterar = "";
  urlRemover = "/";
  urlUpdateTotais ="/updateTotais";
  urlListaComponentes = "/componentes";


  // injetando o HttpClient
  constructor(
    private http: HttpClient
  ) {
  }

  // Headers
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }


  //  /** GET folhasHoras from the server */

  listAplicacoes(): Observable<Aplicacao[]> {
    console.log('listAplicacoes');
    return this.http.get<Aplicacao[]>(this.urlAplicacao + this.urlLista, this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

listSubAplicacoes(codAplicacao: string): Observable<SubAplicacao[]> {
    console.log('listSubAplicacoes ' + codAplicacao);
    return this.http.get<SubAplicacao[]>(this.urlSubAplicacao + this.urlLista + '/' + codAplicacao, this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

listTiposTarefa(): Observable<TipoTarefa[]> {
    console.log('listTiposTarefa');
    return this.http.get<TipoTarefa[]>(this.urlTipoTarefa + this.urlLista, this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }


  searchConcursos(pesquisa: Pesquisa): Observable<Concurso[]> {
    console.log('search', pesquisa);
    console.log('search.json', JSON.stringify(pesquisa));
    return this.http.post<Concurso[]>(this.urlConcurso + this.urlSearch, JSON.stringify(pesquisa), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

countConcursos(filtro: Filtro): Observable<Number> {
    console.log('concursos.count', filtro);
    console.log('concursos.count.json', JSON.stringify(filtro));
    return this.http.post<Number>(this.urlConcurso + this.urlCount, JSON.stringify(filtro), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }


  // Obter folhasConcursos pelo id
  getConcurso(id: number): Observable<Concurso> {
    return this.http.get<Concurso>(this.urlConcurso + this.urlObter + id)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  listComponentes(id: number): Observable<ConcursoAplicacaoTipoTarefa[]> {
    console.log('listComponentes', id);
    return this.http.get<ConcursoAplicacaoTipoTarefa[]>(this.urlConcurso + "/" + id + this.urlListaComponentes, this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  saveComponente(componente: ConcursoAplicacaoTipoTarefa): Observable<ConcursoAplicacaoTipoTarefa> {
    console.log('saveComponente', componente);
    return this.http.post<ConcursoAplicacaoTipoTarefa>(this.urlConcurso + this.urlListaComponentes, JSON.stringify(componente), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

deleteComponente(id: number): Observable<void> {
    console.log('deleteComponente', id);
    return this.http.delete<void>(this.urlConcurso + "/" + id + this.urlListaComponentes, this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  //////// Save methods //////////

  /** POST: add/edit a client to the database */
  saveConcurso(proj: Concurso): Observable<void> {
    console.log('saveConcurso POST ' + this.url + this.urlInserirAlterar);
    console.log(proj);
    return this.http.post<void>(this.urlConcurso + this.urlInserirAlterar, JSON.stringify(proj), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  /** DELETE: delete the client from the server */
  deleteConcurso(proj: Concurso) {
    return this.http.delete<Concurso>(this.urlConcurso + this.urlRemover + proj.codConcurso, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

updateTotaisConcurso(proj: Concurso): Observable<Concurso> {
    console.log('updateTotaisConcurso POST ' + this.url + this.urlUpdateTotais);
    console.log(proj);
    return this.http.post<Concurso>(this.urlConcurso + this.urlUpdateTotais, JSON.stringify(proj), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }



  // Manipulação de erros
  //O angular recomenda que métodos de manipulação de erros devem ser nos serviços e não nos componentes.
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    //console.log(error);
    //console.log(error.error);
    //console.log(error.error.typeof());
    if (typeof(error.error) == "string") {
      errorMessage = error.error;
    } else if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `mensagem: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  };

}
